import store from '@/store';

export default class NewWhatsAppInboxEvent {
  constructor(event) {
    console.log(event.event, event.body);
    store.dispatch('jobs/newInboxJob', event.body);
  }
}
